import React, { useEffect } from "react";
import { observer } from "mobx-react";

import useStores from "@hooks/useStores";

import { Box, Select, MenuItem, Collapse } from "@material-ui/core";

const Travel_DistanceCollapse = observer(({ question, answer, secondary }) => {
	const { travelDistanceCollapseStore: store } = useStores();
	const instance = store.findInstanceByAnswerId(answer._id);

	const onChangeHandler = (e) => instance.update(e.target.value);

	useEffect(() => {
		store.init(question, answer);
		store.watchCollapse(answer._id);
		return () => store.reset();
	}, []);

	return (
		<React.Fragment>
			{instance && (
				<Collapse in={!!store.collapse(answer._id)}>
					<h4 />
					<Select value={instance.distance} onChange={onChangeHandler}>
						<MenuItem value="5">5 miles</MenuItem>
						<MenuItem value="10">10 miles</MenuItem>
						<MenuItem value="15">15 miles</MenuItem>
						<MenuItem value="25">25 miles</MenuItem>
						<MenuItem value="50">50 miles</MenuItem>
					</Select>
				</Collapse>
			)}
		</React.Fragment>
	);
});

export default Travel_DistanceCollapse;
